import { render, staticRenderFns } from "./personalCenterHeader.vue?vue&type=template&id=6c77e08b&scoped=true&"
import script from "./personalCenterHeader.vue?vue&type=script&lang=js&"
export * from "./personalCenterHeader.vue?vue&type=script&lang=js&"
import style0 from "./personalCenterHeader.vue?vue&type=style&index=0&id=6c77e08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c77e08b",
  null
  
)

export default component.exports